<template>
  <div>
    <naj-box :title="local.facility.title">
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.facility.name"
            :value.sync="formModel.name"
            validates="required|arabic"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.number"
            :label="local.facility.number"
            :value.sync="formModel.commercialRegistrationNumber"
            :validates="`${required ? 'required|' : ''}int:true|long|isIdAllowed`"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-address
      :title="local.titleHeader.addressFacility"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'isViewMode'],
};
</script>
